import { createNkfAecEffect } from '../../stream-effects/nkf-aec/createNkfAecEffect';
import { NoiseSuppressionEffect } from '../../stream-effects/noise-suppression/NoiseSuppressionEffect';
import { createVirtualBackgroundEffect } from '../../stream-effects/virtual-background';
import logger from './logger';
/**
 * Loads the enabled stream effects.
 *
 * @param {Object} store - The Redux store.
 * @returns {Promise} - A Promise which resolves when all effects are created.
 */
export default function loadEffects(store) {
    const start = window.performance.now();
    const state = store.getState();
    const virtualBackground = state['features/virtual-background'];
    const noiseSuppression = state['features/noise-suppression'];
    const { noiseSuppression: nsOptions } = state['features/base/config'];
    const nkfAecEnabled = Boolean(state['features/base/config'].nkfAec?.enabled);
    const backgroundPromise = virtualBackground.backgroundEffectEnabled
        ? createVirtualBackgroundEffect(virtualBackground)
            .catch((error) => {
            logger.error('Failed to obtain the background effect instance with error: ', error);
            return Promise.resolve();
        })
        : Promise.resolve();
    // When NKF-AEC is enabled, RNNoise runs as a stage INSIDE the AEC graph
    // (createNkfAecEffect seeds it from the noise-suppression state). Returning
    // a standalone NoiseSuppressionEffect here would win the single track
    // effect slot and clobber the AEC, so skip it in that case.
    const noiseSuppressionPromise = (!nkfAecEnabled && noiseSuppression?.enabled)
        ? Promise.resolve(new NoiseSuppressionEffect(nsOptions))
        : Promise.resolve();
    const nkfAecPromise = createNkfAecEffect(store)
        .catch((error) => {
        logger.error('Failed to obtain the NKF-aec effect instance with error: ', error);
        return Promise.resolve();
    });
    return Promise.all([backgroundPromise, noiseSuppressionPromise, nkfAecPromise]).then(effectsArray => {
        const end = window.performance.now();
        logger.debug(`(TIME) loadEffects() start=${start}, end=${end}, time=${end - start}`);
        return effectsArray;
    });
}
